import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import {getAllMenuCategoriesParentAndChildByLocalId} from '../../../../../../../../crud/menu_api/categories';
import { createMenuWithCategoriesByLocalId } from '../../../../../../../../crud/menu_api/menus';
import { toast } from 'react-toastify';
import { HiOutlineXMark } from 'react-icons/hi2';
import MiniLoadingSpinner from '../../../../../../../../components/Spinners/MiniLoadingSpinner';
import './CreateMenuModal.scss';
import DisplaySelectionCategory from './components/DisplaySelectionCategory';
import { MenuCategoryNode, MenuType } from '../../../../types/menu.types';


interface CreateModalProps {
    show: boolean;
    handleClose: () => void;
    menus:MenuType[];
    setMenus:any;
    refreshMenus: () => void;
}



const CreateMenuModal: React.FC<CreateModalProps> = ({ 
    show, 
    handleClose,
    menus,
    setMenus,
    refreshMenus }) => {
    const [menuForm, setMenuForm] = useState({
        menu_name: '',
        menu_description: '',
        local_id: 0
    });
    const [categories, setCategories] = useState<any[]>([]);
    const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const userContext = localStorage.getItem('user');
        const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
        getAllMenuCategoriesParentAndChildByLocalId(localId)
        .then(response => {
            setCategories(response.data);
        }).catch(error => {
        }).finally(() => {setLoading(false);});
    }, []);

    useEffect(() => {
        const userContext = localStorage.getItem('user');
        const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
        setMenuForm({
            menu_name: '',
            menu_description: '',
            local_id: localId
        });
    },[]);

    const handleFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMenuForm({
            ...menuForm,
            [event.target.name]: event.target.value
        });
    };

    const handleCreateMenu = async (event: React.FormEvent<HTMLFormElement>) => {
        setLoading(true);
        event.preventDefault();
        const userContext = localStorage.getItem('user');
        const localId = userContext ? JSON.parse(userContext).local_id : 0;
        const category_ids = selectedCategories.map((cat) => cat.category_id);
        createMenuWithCategoriesByLocalId(localId, {
            menu_name: menuForm.menu_name,
            menu_description: menuForm.menu_description,
            category_ids: category_ids
        })
        .then((response) => {
            toast.success('Menú creado exitosamente');
            handleClose();
            let new_menu: MenuType = {
                menu_id: response.data.menu_id,
                menu_name: response.data.menu_name,
                menu_description: response.data.menu_description,
                categories: response.data.categories || [],
            };
            if (refreshMenus) {
                    refreshMenus();
            } else {
                const newMenus = [...menus, new_menu];
                setMenus(newMenus);
            }
        })
        .catch((error) => {
            console.error('Error creating menu:', error);
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Error al crear el menú');
            }
        })
        .finally(() => setLoading(false));

    };

    return (
        <Modal className='mp-modal' show={show} onHide={handleClose} size="lg" centered>
            <div className="mp-modal-header">
                <h2 className="mp-modal-title">Crear Menú</h2>
                <button className="mp-modal-close" onClick={handleClose}>
                    <HiOutlineXMark size={18} />
                </button>
            </div>
            <div className="mp-modal-body">
                {loading && <MiniLoadingSpinner />}
                {!loading && 
                <form onSubmit={handleCreateMenu}>
                    <div className="menu-form-container">
                        {/* Basic Information Section */}
                        <div className="form-section">
                            <h4 className="section-title">Información Básica</h4>
                            <div className="mp-form-group">
                                <label className="mp-form-label">Nombre del Menú</label>
                                <input 
                                    className="mp-form-input"
                                    type="text" 
                                    name="menu_name" 
                                    value={menuForm.menu_name} 
                                    onChange={handleFormChange} 
                                    required 
                                    placeholder='Ej: Menú Principal, Menú de Temporada...'
                                />
                            </div>
                            <div className="mp-form-group">
                                <label className="mp-form-label">Descripción</label>
                                <textarea
                                    className="mp-form-input mp-form-textarea"
                                    rows={2}
                                    name="menu_description" 
                                    value={menuForm.menu_description} 
                                    onChange={(e: any) => handleFormChange(e)} 
                                    placeholder='Descripción opcional del menú...'
                                />
                            </div>
                        </div>

                        {/* Category Selection Section */}
                        <div className="form-section">
                            <div className="section-header">
                                <h4 className="section-title">Seleccionar Categorías</h4>
                                <div className="section-description">
                                    <p>Las categorías mantienen su estructura jerárquica en todos los menús. Si una categoría tiene subcategorías, estas aparecerán organizadas de la misma manera.</p>
                                </div>
                            </div>
                            <DisplaySelectionCategory 
                                categories={categories} 
                                selectedCategories={selectedCategories} 
                                setSelectedCategories={setSelectedCategories} 
                            />
                        </div>
                    </div>
                    <div className="mp-modal-footer">
                        <button type="button" className="mp-modal-btn-cancel" onClick={handleClose}>
                            Cancelar
                        </button>
                        <button 
                            type="submit" 
                            className="mp-modal-btn-submit" 
                            disabled={loading || !menuForm.menu_name.trim()}
                        >
                            Crear Menú
                        </button>
                    </div>
                </form>}
            </div>
        </Modal>
    );
};

export default CreateMenuModal;


